const steps = [
  {
    number: '01',
    icon: 'ri-mail-send-line',
    title: 'Enquire',
    desc: 'Get in touch with your event details, rough size, and location. No commitment needed.',
  },
  {
    number: '02',
    icon: 'ri-map-pin-2-line',
    title: 'Site Consultation',
    desc: 'Our team visits your site to assess the space and discuss your vision in detail.',
  },
  {
    number: '03',
    icon: 'ri-draft-line',
    title: 'Design & Quote',
    desc: 'We create a custom design proposal with full pricing and technical drawings.',
  },
  {
    number: '04',
    icon: 'ri-hammer-line',
    title: 'Installation',
    desc: 'Our expert crew handles the complete installation efficiently and professionally.',
  },
];

export default function ProcessSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white border-t border-gray-100">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-3">How It Works</h2>
          <p className="text-gray-500 text-base">
            From first contact to finished installation, a simple, transparent process.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-0">
          {steps.map((step, index) => (
            <div key={index} className="relative flex flex-col items-center text-center px-4">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-px bg-teal-100 z-0"></div>
              )}
              {/* Icon circle */}
              <div className="relative z-10 w-16 h-16 bg-teal-400 rounded-full flex items-center justify-center mb-5 flex-shrink-0">
                <i className={`${step.icon} text-2xl text-white`}></i>
              </div>
              <span className="text-teal-300 text-xs font-bold tracking-widest mb-1">
                STEP {step.number}
              </span>
              <h3 className="font-bold text-gray-900 text-lg mb-2">{step.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
